// Approximate geographic centroids for placing listener markers on the map.
export const US_STATE_CENTROIDS = {
  "Alabama": [32.8, -86.8], "Alaska": [64.7, -152.4], "Arizona": [34.3, -111.7],
  "Arkansas": [34.9, -92.4], "California": [37.2, -119.4], "Colorado": [39.0, -105.5],
  "Connecticut": [41.6, -72.7], "Delaware": [39.0, -75.5], "Florida": [28.6, -82.4],
  "Georgia": [32.6, -83.4], "Hawaii": [20.3, -156.4], "Idaho": [44.4, -114.6],
  "Illinois": [40.0, -89.2], "Indiana": [39.9, -86.3], "Iowa": [42.0, -93.5],
  "Kansas": [38.5, -98.4], "Kentucky": [37.5, -85.3], "Louisiana": [31.0, -92.0],
  "Maine": [45.4, -69.2], "Maryland": [39.0, -76.8], "Massachusetts": [42.3, -71.8],
  "Michigan": [44.3, -85.6], "Minnesota": [46.3, -94.3], "Mississippi": [32.7, -89.7],
  "Missouri": [38.4, -92.5], "Montana": [46.9, -110.4], "Nebraska": [41.5, -99.8],
  "Nevada": [39.3, -116.6], "New Hampshire": [43.7, -71.6], "New Jersey": [40.2, -74.7],
  "New Mexico": [34.4, -106.1], "New York": [42.9, -75.5], "North Carolina": [35.6, -79.4],
  "North Dakota": [47.4, -100.5], "Ohio": [40.3, -82.8], "Oklahoma": [35.6, -97.5],
  "Oregon": [44.0, -120.5], "Pennsylvania": [40.9, -77.8], "Rhode Island": [41.7, -71.5],
  "South Carolina": [33.9, -80.9], "South Dakota": [44.4, -100.2], "Tennessee": [35.9, -86.4],
  "Texas": [31.5, -99.3], "Utah": [39.3, -111.7], "Vermont": [44.1, -72.7],
  "Virginia": [37.5, -78.9], "Washington": [47.4, -120.5], "West Virginia": [38.6, -80.6],
  "Wisconsin": [44.6, -89.9], "Wyoming": [43.0, -107.5], "District of Columbia": [38.9, -77.0],
};

export const COUNTRY_CENTROIDS = {
  "United States": [39.8, -98.6], "Canada": [56.1, -106.3], "United Kingdom": [55.4, -3.4],
  "Ireland": [53.4, -8.2], "Australia": [-25.3, 133.8], "New Zealand": [-40.9, 174.9],
  "Nigeria": [9.1, 8.7], "Ghana": [7.9, -1.0], "Kenya": [-0.02, 37.9], "South Africa": [-30.6, 22.9],
  "Jamaica": [18.1, -77.3], "Trinidad and Tobago": [10.7, -61.2], "Bahamas": [25.0, -77.4],
  "Barbados": [13.2, -59.5], "India": [20.6, 79.0], "Philippines": [12.9, 121.8],
  "Mexico": [23.6, -102.6], "Brazil": [-14.2, -51.9], "Germany": [51.2, 10.5], "France": [46.6, 2.2],
  "Netherlands": [52.1, 5.3], "Sweden": [60.1, 18.6], "Norway": [60.5, 8.5],
};

export function locationLatLng(loc) {
  if (loc.country === "United States" && loc.state && US_STATE_CENTROIDS[loc.state]) {
    return US_STATE_CENTROIDS[loc.state];
  }
  return COUNTRY_CENTROIDS[loc.country] || null;
}

export function locationLabel(loc) {
  if (loc.country === "United States" && loc.state) return `${loc.state}, USA`;
  return loc.country;
}
